import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { EntityRoleSlugEnum } from '../../../../dave-data-module/entities/entity-role.entity';
import { EventEntity } from '../../../../dave-data-module/entities/event.entity';
import { CommissionResolver } from '../../../../dave-data-module/guards/commission.resolver';
import { EntityRoleResolver } from '../../../../dave-data-module/guards/entity-role.resolver';
import { UserToCommissionResolver } from '../../../../dave-data-module/guards/user-to-commission.resolver';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { State } from '../../../../dave-data-module/State';
import { getCommissionById, getCommissionsFetched } from '../../../../dave-data-module/State/selectors/commission.selector';
import { getEntityRoleDictionary, getEntityRoleFetched } from '../../../../dave-data-module/State/selectors/entity-role.selector';
import { getUserToCommissionByCommissionId, getUserToCommissionFetched } from '../../../../dave-data-module/State/selectors/user-to-commission.selector';
import { getUser } from '../../../../dave-data-module/State/selectors/users.selectors';
import { isNotNullOrUndefined, uniqArray } from '../../../../helper/helper';
import { AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn } from '../add-event-dialog/add-event-dialog.component';
import { CategoriesWithAssignments } from '../../../../dave-data-module/services/event-categories.service-data-service';
import { filter, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class InterruptionEventService {
    constructor(private store: Store<State>, private dialog: MatDialog, private userToCommissionResolver: UserToCommissionResolver, private entityRoleResolver: EntityRoleResolver, private commissionResolver: CommissionResolver) {}

    private async getRoles(userId: number, commissionId: number) {
        const commission = await firstValueFrom(getFetched$(this.store, getCommissionsFetched, getCommissionById({ id: commissionId }), this.commissionResolver));
        const userToCommissions = await firstValueFrom(getFetched$(this.store, getUserToCommissionFetched, getUserToCommissionByCommissionId({ commissionId: commission.Id }), this.userToCommissionResolver));
        const meToCommission = userToCommissions.filter((u2c) => u2c.UserId === userId);
        const myRoleIds = uniqArray(meToCommission.map((u2c) => u2c.RoleId)).filter(isNotNullOrUndefined);
        if (myRoleIds.length === 0) {
            return [];
        }
        const entityRoles = await firstValueFrom(getFetched$(this.store, getEntityRoleFetched, getEntityRoleDictionary, this.entityRoleResolver));
        return myRoleIds.map((id) => entityRoles[id]);
    }
    public async OpenEditEventDialog(event: Partial<EventEntity>, commissionId: number, element?: HTMLElement, resCategories? : CategoriesWithAssignments) {
        const me = await firstValueFrom(this.store.select(getUser));
        let deletePermission = me.Id === event.UserId;

        if (!deletePermission) {
            const myRoles = await this.getRoles(me.Id, commissionId);
            deletePermission = myRoles.some((role) => role?.Name === EntityRoleSlugEnum.Admin || role?.Name === EntityRoleSlugEnum.Projektleiter);
        }
        element?.classList.add('is-active');
        this.dialog
            .open<AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn>(AddEventDialogComponent, {
                ...AddEventDialogComponent.DefaultConfig,
                data: {
                    eventId: event.Id,
                    hideDate: false,
                    canDelete: deletePermission,
                    categories: resCategories,
                    eventTypeId: event.EventTypeId,
                },
            })
            .afterClosed()
            .subscribe(() => document.addEventListener('click', () => element?.classList.remove('is-active'), { once: true }));
    }
}
